import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SpiritualBackground from './components/SpiritualBackground';
import LoginCard from './components/LoginCard';

const LoginScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Spiritual Background */}
      <SpiritualBackground />
      
      {/* Login Card */}
      <LoginCard />
    </div>
  );
};

export default LoginScreen;